import { applyTransaction } from '@datorama/akita';
import { addDays } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { query } from 'state/Design/query';
import store from 'state/Design/store';
import baseClient from 'utils/axiosBaseClient';

export default class DesignService {
   private readonly baseClient: typeof baseClient;
   private readonly store: typeof store;
   private readonly query: typeof query;

   constructor() {
      this.baseClient = baseClient;
      this.store = store;
      this.query = query;
   }

   getDesign() {
      const localStorageKey = 'designServiceDataObject';
      const cachedData = localStorage.getItem(localStorageKey);
      const now = new Date();

      if (cachedData) {
         const parsedData = JSON.parse(cachedData);
         if (now.getTime() < parsedData.expiry) {
            return Promise.resolve(parsedData.value).then((data) => {
               applyTransaction(() => {
                  this.store.update(data);
                  this.store.setLoading(false);
               });
               return data;
            });
         } else {
            localStorage.removeItem(localStorageKey);
         }
      }

      return this.baseClient
         .get(`/auth/design`)
         .then((resp) =>
            applyTransaction(() => {
               this.store.update(resp.data);
               this.store.setLoading(false);
               const dataToStore = {
                  value: resp.data,
                  expiry: addDays(now, 1).getTime(),
               };
               localStorage.setItem(localStorageKey, JSON.stringify(dataToStore));
            })
         )
         .catch((error) => {
            applyTransaction(() => {
               this.store.setError({
                  code: error?.response?.status ?? error?.response?.data?.code,
                  variant: 'error',
                  message: `${error?.response?.data?.message ?? error.message ?? ''} ${error?.response?.data?.error ?? ''}`,
                  key: `${this.store?.storeName}#${uuidv4()}`,
                  store: this.store?.storeName,
               });
               this.store.setLoading(false);
            });
         });
   }
}
